module.exports = __webpack_public_path__ + "img/ball_6_black.49445404.png";